module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/app/logo-942005f03981eb217e2fedd56ce36f27.svg";